// Vendor imports
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('BottomCallToActionSection')

function BottomCallToActionSection(props) {
  const onButtonClick = props.isSULandingPage
    ? props.onSULoginClick
    : props.onSignupClick
  return tag('div', {
    className: bem.block()
  },
    tag('div', {
      className: bem.element('content')
    },
      tag('div', {
        className: bem.element('heading')
      },
        `Curate the`,
        tag('br'),
        `best of the internet`
      ),

      tag('div', {
        className: bem.element('subheading')
      },
        `Create collections of interesting things`,
        tag('br'),
        `to share them with your friends.`
      ),

      tag('div', {
        className: bem.element('buttons-container')
      },
        tag('button', {
          className: bem.element('button', 'primary'),
          onClick: onButtonClick
        },
          `Join Mix`
        )
      )
    ),
    tag('div', {
      className: bem.element('image')
    })
  )
}

BottomCallToActionSection.propTypes = {
  // Flags
  isSULandingPage: PropTypes.bool.isRequired,
  // Callbacks
  onSignupClick: PropTypes.func.isRequired,
  onSULoginClick: PropTypes.func.isRequired
}

module.exports = BottomCallToActionSection
